var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{attrs:{"title":_vm.$d(_vm.date_, 'long')}},[_vm._v(_vm._s(_vm.ago))])
}
var staticRenderFns = []

export { render, staticRenderFns }